var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.999219 8.30005L6.69922 13.9C7.09922 14.3 7.69922 14.3 8.09922 13.9C8.49922 13.5 8.49922 12.9 8.09922 12.5L3.19922 7.50005L8.09922 2.50005C8.49922 2.10005 8.49922 1.50005 8.09922 1.10005C7.89922 0.900049 7.69922 0.800049 7.39922 0.800049C7.09922 0.800049 6.89922 0.900049 6.69922 1.10005L0.999219 6.70005C0.599219 7.20005 0.599219 7.80005 0.999219 8.30005C0.999219 8.20005 0.999219 8.20005 0.999219 8.30005Z",
    fill: "#776F6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.b77355214428e0cfae13424deb59a900.svg";
export { ForwardRef as ReactComponent };